import request from "@/utils/http"

export function getAllWorkflow(appId) {
  return request.get("/sheet/workflows/all", { params: { appId } }).commonDeal()
}

export function getWorkflows(id) {
  return request.get(`/sheet/workflows/list/${id}`).commonDeal()
}

export function getWorkflow(id) {
  return request.get(`/sheet/workflows/${id}`).commonDeal()
}

export function getMainProcess(subProcessId) {
  return request.get(`/sheet/getMainProcess`, { params: { subProcessId } }).commonDeal()
}

export function createWorkflow(workflow, appId) {
  return request.post("/sheet/workflows", workflow, { params: { appId } })
}

export function copyWorkflow(workflow, originalId) {
  return request.post("/sheet/workflows/copy", workflow, { params: { originalId } })
}

export function updateWorkflow(workflow) {
  return request.post("/sheet/workflows/update", workflow).commonDeal()
}

export function deleteWorkflow(id) {
  return request.get(`/sheet/workflows/delete/${id}`)
}

export function getWorkflowVars(workFlowId, processId) {
  return request.get(`/sheet/getWorkflowVars/${workFlowId}/${processId}`).commonDeal()
}

export function deployWorkflow(workFlowId) {
  return request.post(`/sheet/workflows/deploy/${workFlowId}`).commonDeal()
}

export function rollbackWorkflow(workFlowId) {
  return request.post(`/sheet/workflows/rollback/${workFlowId}`).commonDeal()
}

export function changeWorkflowState(workFlowId, state) {
  return request
    .post(`/sheet/workflows/changeState?workflowId=${workFlowId}&state=${state}`)
    .commonDeal()
}

export function getApprovalFlowTemplates(companyId) {
  return request.get("/task/getApprovalFlowTemplates", { params: { companyId } }).commonDeal()
}

export function retryServiceTaskSync(executionId) {
  return request
    .post(`/flowable/retryServiceTaskSync`, null, { params: { executionId } })
    .commonDeal()
}
